import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const ACCIDENT_SURGERY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY>
> = [
  {
    key: "main_diagnosis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.diagnosisLabel,
  },
  {
    key: "therapy",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.therapyLabel,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.anamnesisLabel,
  },
  {
    key: "social_anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .socialAnamnesisLabel,
  },
  {
    key: "allergies",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.allergiesLabel,
  },
  {
    key: "admission_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .admissionFindingsLabel,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.labResultsLabel,
  },
  {
    key: "ecg",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.ecgLabel,
  },
  {
    key: "further_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .furtherFindingsLabel,
  },
  {
    key: "progress",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.progressLabel,
  },
  {
    key: "discharge_recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .dischargeRecommendationLabel,
  },
  {
    key: "appointments",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .appointmentsLabel,
  },
  {
    key: "parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery.parametersLabel,
  },
  {
    key: "medication_upon_discharge",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formTraumSurgery
        .dischargeMedicationLabel,
  },
];

export function createAccidentSurgeryDischargeLetterPdf(
  props: PdfCreatorProps<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY
  >,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY
  >(props, ACCIDENT_SURGERY_FIELD_CONFIG);
}
